import styled from 'styled-components';
import { theme } from '../../../theme';

export const DivLimitIndicator = styled.div`
  display: inline-block;
  font-size: 0.923rem;
  font-weight: 500;
  color: ${theme.colors.secondary};
`;
